import Delay from '@/webgl/core/Delay'
import Signal from '@/webgl/core/Signal'
import ColorTransition from '@/webgl/runner/animations/ColorTransition'
import { TimeEntity } from '@/webgl/runner/entities/Time'
import GameWorld from '@/webgl/runner/GameWorld'
import { IRunnerRenderer } from '@/webgl/runner/interfaces/IRunnerRenderer'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'
import ScrollSystem from '@/webgl/runner/systems/ScrollSystem'
import { IGameSegment } from '@/webgl/runner/systems/SequencingSystem'

export default class CarisSoloTransition implements IGameSegment {
  onComplete: Signal<void> = new Signal<void>()
  world: GameWorld
  renderer: IRunnerRenderer
  setup: ScenarioSetup
  stopped: boolean = true

  constructor(readonly id: string = 'caris_solo_transition') {}

  init(world: GameWorld, renderer: IRunnerRenderer, setup: ScenarioSetup): void {
    this.world = world
    this.renderer = renderer
    this.setup = setup
  }

  async start() {
    this.world.getTrackingSystem().trackImpression({
      unitName: `caris_simulation_1`,
      unitVariation: `scenario_auto_obstacle_solodance`,
      unitLocation: 'tyce',
    })

    this.stopped = false
    this.world.systems.get<ScrollSystem>(ScrollSystem).enable()

    const duration = 0.8

    // Background
    const t1 = new ColorTransition(this.setup.backgroundColor)
    t1.to(0x024860, {
      duration,
      onUpdate: () => {
        this.renderer.background.setColor(t1.Hex)
        this.renderer.player.setColors(t1.Hex, this.setup.playerGoodColor, this.setup.playerWrongColor)
        this.renderer.lanes.setMaskColor(t1.Hex)
      },
    })

    // Clear color
    const t2 = new ColorTransition(this.setup.clearColor)
    t2.to(0x002938, {
      duration,
      onUpdate: (d) => this.renderer.glRenderer.setClearColor(t2.Hex),
    })

    // Lane
    const t3 = new ColorTransition(this.setup.lanesColor)
    t3.to(0x06748d, {
      duration: 1.4,
      onUpdate: (d) => this.renderer.lanes.setColor(t3.Hex),
    })

    // Lane extra
    const t4 = new ColorTransition(this.setup.lanesExtraColor)
    t4.to(0x4ea4bd, {
      duration: 1.4,
      onUpdate: (d) => this.renderer.lanes.scroll.setTintColor(t4.Hex),
    })

    await Delay(1000)
    this.renderer.spotlights.reveal()

    this.onComplete.emit()
  }

  update?(time: TimeEntity): void {}

  stop(): void {
    this.stopped = true
  }
}
